<template>
  <div id="bto-parts-palette-panel">
    <slot name="parts-info"></slot>
    <slot name="parts-label"></slot>
    <slot name="parts-list"></slot>
  </div>
</template>

<script>
export default {
  name: "PanelPartsPalette",
};
</script>

<style scoped lang="stylus">

@css {
  #bto-parts-palette-panel {
    @apply text-left text-xs
  }
}
</style>
